import { Link } from '@tanstack/react-router';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumbs({ items, className }: { items: Crumb[]; className?: string }) {
  return (
    <nav className={cn('text-muted-foreground flex items-center gap-1 text-sm', className)}>
      <Link to="/" className="hover:text-foreground inline-flex items-center gap-1">
        <Home className="h-3.5 w-3.5" />
      </Link>
      {items.map((c, i) => (
        <span key={i} className="flex items-center gap-1">
          <ChevronRight className="text-muted-foreground/50 h-3.5 w-3.5" />
          {c.to ? (
            <Link to={c.to} className="hover:text-foreground truncate">
              {c.label}
            </Link>
          ) : (
            <span className="text-foreground truncate font-medium">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
